import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaInstagram, FaFacebook, FaTheaterMasks } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import danceImage from './assets/danse.jpeg';
import mannequinatImage from './assets/manequinat.jpeg';
import heroBg from './assets/hero-bg.jpeg';

const App = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative min-h-[400px] md:min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: '50% 30%',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Overlay sombre pour améliorer la lisibilité */}
        <div className="absolute inset-0 bg-black/50"></div>
        
        {/* Contenu */}
        <div className="relative z-10 text-center text-white px-4">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-6xl font-bold mb-6"
          >
            LES ÉTOILES SUR LE PODIUM
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl mb-8"
          >
            Association des Mannequins et Danseurs de Montagnat
          </motion.p>
          <motion.a
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            href="#contact"
            className="inline-block bg-gold text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-gold-dark transition-colors"
          >
            Contactez-nous
          </motion.a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section bg-white">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h2 className="text-4xl font-bold mb-8 text-black">À Propos</h2>
            <p className="text-lg mb-6 text-black">
              L'Association des Mannequins et Danseurs de la Commune de Montagnat est un collectif artistique 
              dédié à la promotion du talent local dans les domaines de la mode, de la danse contemporaine 
              et des arts de la scène.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Activities Section */}
      <section id="activities" className="section bg-white">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-4xl font-bold text-center mb-12 text-black">Nos Activités</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="p-8 bg-white rounded-lg shadow-lg"
            >
              <div className="w-16 h-16 mb-4 overflow-hidden rounded-full">
                <img src={danceImage} alt="Cours de danse" className="w-full h-full object-contain" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-black">Cours de Danse</h3>
              <p className="text-black">Moderne, afro, urbain</p>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="p-8 bg-white rounded-lg shadow-lg"
            >
              <div className="w-16 h-16 mb-4 overflow-hidden rounded-full">
                <img src={mannequinatImage} alt="Ateliers de mannequinat" className="w-full h-full object-contain" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-black">Ateliers de Mannequinat</h3>
              <p className="text-black">Port de tenue, posture, défilé</p>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="p-8 bg-white rounded-lg shadow-lg"
            >
              <FaTheaterMasks className="w-12 h-12 text-black mb-4" />
              <h3 className="text-2xl font-bold mb-4 text-black">Événements</h3>
              <p className="text-black">Spectacles, défilés, shootings, compétitions</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section bg-white">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-8 text-black">Contactez-nous</h2>
            <div className="flex justify-center space-x-6 mb-8">
              <a href="https://www.instagram.com/les_etoiles_sur_le_podium/" className="text-2xl text-gold hover:text-gold-dark transition-colors">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/p/Les-%C3%A9toiles-sur-le-podium-100063186192537/" className="text-2xl text-gold hover:text-gold-dark transition-colors">
                <FaFacebook />
              </a>
            </div>
            <a href="mailto:lesetoilesurlepodium@gmail.com" className="flex items-center justify-center space-x-2 text-lg text-black hover:text-gold transition-colors">
              <MdEmail className="text-gold" />
              <span>lesetoilesurlepodium@gmail.com</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-8">
        <div className="container mx-auto text-center">
          <p>Montagnat, Ain (01), région Auvergne-Rhône-Alpes, France</p>
        </div>
      </footer>
    </div>
  );
};

export default App;
